import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import calendar from '../../assets/images/Calendar.svg';
import './CommonInput.scss';

const CommonInput = ({ type, label, value, onChange, placeholder, error, onFocus, onBlur, id, focused, disabled, onKeyDown, onKeyPress, ref, ariaInvalid, wrapperClassName,wrapperClassNameCalender, isOnlyErrorBorder, inputType = 'text', calendarRef, appendTo, ...props }) => {
    const renderInput = () => {
        switch (type) {
            case 'text':
                return (
                    <InputText
                        value={value || ""}
                        onChange={onChange}
                        placeholder={placeholder}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        id={id}
                        className={`p-inputtext ${value ? "p-filled" : ""}`}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        onKeyPress={onKeyPress}
                        ref={ref}
                        aria-invalid={ariaInvalid}
                        type={inputType}
                        {...props}
                    />
                );
            case 'calendar':
                return (
                    <>
                        <Calendar
                            value={value}
                            onChange={onChange}
                            placeholder={placeholder}
                            onFocus={onFocus}
                            onBlur={onBlur}
                            id={id}
                            dateFormat="dd M yy"
                            minDate={props.minDate}
                            maxDate={props.maxDate}
                            disabled={disabled}
                            className={`${value ? "p-filled" : ""}`}
                            ref={props.calendarRef}
                        />
                        <img
                            src={calendar}
                            alt="calendar"
                            className="custom-calendar-icon"
                            onClick={() => calendarRef?.current?.show()}
                        />
                    </>

                );
            default:
                return (
                    <InputText
                        value={value || ""}
                        onChange={onChange}
                        placeholder={placeholder}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        id={id}
                        className={`p-inputtext ${value ? "p-filled" : ""}`}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        ref={ref}
                        type={inputType}
                        {...props}
                    />
                );
        }
    };

    return (
        <div className={`Common-input ${type === 'calendar' && wrapperClassNameCalender ? wrapperClassNameCalender : ''} ${wrapperClassName ? wrapperClassName : ''} ${disabled ? 'common-disabled' : ''} ${!disabled && error ? "red-border" : ""}`}>
            <div className={`p-float-label ${value ? "p-filled" : ""} ${focused ? "custom-float-label" : ""}`}>
                {renderInput()}
                <label htmlFor={id}>{label}</label>
            </div>
            {error && !isOnlyErrorBorder && <span className="common-input-error">{error}</span>}
        </div>
    );
};

export default CommonInput;